export default "__VITE_ASSET__DdZnrtL5__"